import { useConfirmEmailMutation } from '@generated/graphql';
import { CircularLoading, useToast } from '@myhrbox/myhrbox-frontend-core';
import ROUTES from 'constants/routes';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ConfirmEmail = () => {
  const { t } = useTranslation();
  const { showErrorToast, showSuccessToast } = useToast();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [confirmEmail] = useConfirmEmailMutation();

  useEffect(() => {
    if (!token) {
      showErrorToast(t('errors.common'));
      navigate(ROUTES.ASSESSMENT, { replace: true });
      return;
    }

    confirmEmail({ variables: { token } })
      .then((res) => {
        if (!res.data?.confirmEmail) throw new Error('confirmEmail failed');
        showSuccessToast(t('register.confirmSuccess'));
      })
      .catch(() => {
        showErrorToast(t('errors.common'));
      })
      .finally(() => {
        navigate(ROUTES.ASSESSMENT, { replace: true });
      });
  }, [confirmEmail, token]);

  return <CircularLoading />;
};

export default ConfirmEmail;
